import { REACT_APP_UNAUTHORIZED_REDIRECT } from "../constants";

export const headers = (token, sessionToken) => {
  if (token) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
      // ...(sessionToken && {'x-api-key': sessionToken}), // For connectives
      ...(sessionToken && { "x-api-key": sessionToken }), // For connectives
    };
  }

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

const parseResponseBody = async (response) => {
  const text = await response.text();
  if (!text) return null;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }
  return text;
};

const buildAxiosLikeError = (response, body) => {
  const error = new Error(`Request failed with status ${response.status}`);
  error.response = { status: response.status, data: body, headers: response.headers };
  return error;
};

export const reusableFetch = async (url, method, data, rejectWithValue) => {
  const token = localStorage.token;
  const sessionToken = sessionStorage.token;
  try {
    const init = {
      method,
      headers: headers(token, sessionToken),
    };
    if (data && method !== "GET" && method !== "HEAD") {
      init.body = JSON.stringify(data);
    }
    const response = await fetch(`${process.env.REACT_APP_API_URL}/${url}`, init);
    const body = await parseResponseBody(response);
    if (!response.ok) throw buildAxiosLikeError(response, body);
    return { data: body, status: response.status, headers: response.headers };
  } catch (error) {
    // if (error.response.status === 404) {
    //   const origin = window.location.origin;
    //   console.log(origin);
    //    window.location.replace(`${origin}/404`);
    // }

    if (error?.response?.status === 401) {
      localStorage.setItem("tokenExpired", true);
      localStorage.removeItem("token");
      // window.location.reload();
      window.location.replace(REACT_APP_UNAUTHORIZED_REDIRECT);
    }
    // if (error.response.status === 403) {
    //  window.location.replace(`${origin}/404`);
    //   // window.history.back();

    // }
    return rejectWithValue(error?.response ? error.response.data : error);
  }
};

export const reusableWithoutTokenFetch = async (url, method, data, rejectWithValue) => {
  try {
    const init = {
      method,
      headers: headers(),
    };
    if (data && method !== "GET" && method !== "HEAD") {
      init.body = JSON.stringify(data);
    }
    const response = await fetch(`${process.env.REACT_APP_API_URL}/${url}`, init);
    const body = await parseResponseBody(response);
    if (!response.ok) throw buildAxiosLikeError(response, body);
    return { data: body, status: response.status, headers: response.headers };
  } catch (error) {
    if (error?.response?.status === 401) {
      if (error?.response?.status === 401) {
        localStorage.setItem("tokenExpired", true);
        localStorage.removeItem("token");
        // window.location.reload();
        // window.location.replace(REACT_APP_UNAUTHORIZED_REDIRECT);
      }
    }
    // if (error.response.status === 403) {
    //     window.location.replace(`${origin}/404`);
    // }
    return rejectWithValue(error?.response ? error.response.data : error);
  }
};

export const reusableFormDataFetch = async (url, method, formData, rejectWithValue) => {
  const token = localStorage.token;
  const formDataHeaders = headers(token);
  // Let the browser set Content-Type with the proper multipart boundary.
  delete formDataHeaders["Content-Type"];
  delete formDataHeaders.Accept;

  try {
    if (formData) {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
        method,
        headers: formDataHeaders,
        body: formData,
      });
      const body = await parseResponseBody(response);
      if (!response.ok) throw buildAxiosLikeError(response, body);
      return { data: body, status: response.status, headers: response.headers };
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.setItem("tokenExpired", true);
      localStorage.removeItem("token");
      // window.location.reload();
      window.location.replace(REACT_APP_UNAUTHORIZED_REDIRECT);
    }
    // if (error.response.status === 403) {
    //   window.location.replace(`${origin}/404`);
    //   // window.history.back();
    // }
    return rejectWithValue(error?.response ? error.response.data : error);
  }
};

export const getUserInfo = async ({ access_token }) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_CONNECTIVE_USER_INFO_URL}`, {
      method: "GET",
      headers: headers(access_token),
    });
    const body = await parseResponseBody(response);
    if (!response.ok) throw buildAxiosLikeError(response, body);
    const result = { data: body, status: response.status, headers: response.headers };
    console.log("getUserInfo_response ::", result);
    return result;
  } catch (error) {
    console.log("getUserInfo_error ::", error);
    if (error?.response?.status === 401) {
      localStorage.setItem("tokenExpired", true);
      localStorage.removeItem("token");
      // window.location.replace(REACT_APP_UNAUTHORIZED_REDIRECT);
    }
  }
};
